export class ResultBaseModel {
    isValid: boolean;
    errors: Array<string>;
}
